module.exports = __webpack_public_path__ + "static/img/pr_bg_4.e7124e3a.png";